import ic_clock from "../../assets/icons/ic_clock.svg";
import { useCallback, useEffect, useState } from "react";
import {
  getAllModules,
  getExercises,
  getExercisesById,
  getModules,
  getStandaloneExercise,
  getUserPlaylist,
} from "../../api/api";
import { Playlists, SkeletonPlaylist } from "../home/Playlists";
import {
  MemoizedExerciseList,
  SkeletonExerciseList,
} from "../playlistDialog/Exercise";
import {
  BlueLinearGradient,
  BlueTextLinearGradient,
  WhiteLinearGradient,
} from "../../utils/Utils";
import { useLocation, useNavigate } from "react-router-dom";
import CreateRoutineDialog from "../playlistDialog/CreateRoutineDialog";

function PracticePage() {
  const [exercises, setExercises] = useState();
  const [userPlaylists, setUserPlaylists] = useState();

  async function updateExerciseList() {
    let response = await getStandaloneExercise();
    const list = {};
    Object.keys(response).map((category, categoryIndex) => {
      const exercises = [];
      response[category].forEach((element) => {
        exercises.push({
          exerciseName: element.exerciseName,
          description: element.exercisesBenefits,
          details: [
            {
              icon: ic_clock,
              text: element.exercisesDuration + " secs",
              alwaysShow: true,
            },
            {
              text: element.exercisescoinsMultipli,
              alwaysShow: false,
            },
          ],
          exerciseUri: element.exerciseURI,
          id: element.exerciseId,
          exerciseImage: element.activityImage,
          exerciseVideo: element.exerciseVideo,
          exerciseAudio: element.exerciseAudio,
          exerciseUrl: element.testURL,
          category: category,
        });
      });
      list[category] = exercises;
    });
    setExercises(list);
  }

  const [selectedExercises, setSelectedExercise] = useState([]);
  const [showCreateRoutine, setShowCreateRoutine] = useState(false);

  const userPlaylistModified = useCallback(() => {
    updateUserPlaylists();
  }, []);

  async function updateUserPlaylists() {
    setUserPlaylists([]);
    const response = await getUserPlaylist();
    setUserPlaylists(response);
  }

  const location = useLocation();
  const navigate = useNavigate();
  const getShareExercises = async () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);
      if (query.get("id")) {
        const response = await getExercisesById(query.get("id"));
        if (response) {
          if (response[0]) {
            window.location.href = response[0].url;
            // navigate(response[0].url);
          }
        }
      }
    }
  };

  useEffect(() => {
    getShareExercises();
  }, []);

  useEffect(() => {
    updateExerciseList();
    // updateUserPlaylists();
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={`w-full relative bg-black-100`}>
      <CreateRoutineDialog
        open={showCreateRoutine}
        close={() => {
          setShowCreateRoutine(false);
        }}
        exercises={exercises}
      />
      <div className=" px-6 md:px-16 lg:px-24 2xl:px-32 mt-10">
        <div
          className="flex items-center md:flex-row flex-col md:space-y-0 space-y-6  bg-black-300 rounded-lg w-full md:px-12 px-6 md:py-3 py-6 mb-10 "
          // className="flex items-center bg-black-300 rounded-lg w-full px-6 py-3 mb-10"
        >
          <p
            className={`font-medium flex flex-1  ${BlueTextLinearGradient} font-poppins text-xl `}
          >
            Create your own routine from a range of focussed exercises
          </p>
          <div
            className="rounded-full cursor-pointer px-5 py-2 bg-primary-neonGreen"
            onClick={() => {
              setShowCreateRoutine(true);
            }}
          >
            Create a Routine
          </div>
        </div>
        {/* {userPlaylists ? (
          userPlaylists.length > 0 && (
            <Playlists
              playlistName={"My Routines"}
              playlist={userPlaylists}
              userPlaylist
              onPlaylistDelete={() => {
                updateUserPlaylists();
              }}
            />
          )
        ) : (
          <SkeletonPlaylist numberOfPlaylist={1} />
        )} */}
        <p className="capitalize font-poppins  text-white font-extrabold text-3xl ">
          <span className="text-primary-neonGreen">Browse</span>
          {"  "} All Exercises
        </p>
        {exercises ? (
          Object.keys(exercises).map((category, categoryIndex) => {
            return (
              <MemoizedExerciseList
                title={category}
                exerciseList={exercises[category]}
                initialOpen={true}
                showInstructionBeforeRedirect
                onUserPlaylistUpdate={userPlaylistModified}
                selectedExercises={selectedExercises}
                setSelectedExercise={setSelectedExercise}
              />
            );
          })
        ) : (
          <SkeletonExerciseList />
        )}
      </div>
    </div>
  );
}

export default PracticePage;
